import { render } from "./MultiBoxToggle.vue?vue&type=template&id=12956c26&scoped=true"
import script from "./MultiBoxToggle.vue?vue&type=script&lang=js"
export * from "./MultiBoxToggle.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12956c26"]])

export default __exports__